import { Box, Typography } from "@mui/material";
import { useLanguage } from "../../../../context/LanguageContext";
import { Colors } from "../../../../styles/theme";
import platformStyles from "../Platform/Platform.styles";

const About = () => {
  const { translate, selectedLanguage } = useLanguage();
  const isRTL = selectedLanguage === "ar";

  return (
    <Box
      component="section"
      id="about-sharp-view"
      sx={{
        ...platformStyles.Platform_container,
        backgroundColor: Colors.white,
        direction: isRTL ? "rtl" : "ltr",
      }}
    >
      <Box
        sx={{
          ...platformStyles.Platform_textContainer,
          maxWidth: "1200px",
          boxSizing: "border-box",
          px: { xs: 1, sm: 3, md: 5 },
        }}
      >
        <Typography
          variant="subtitle2"
          component="p"
          color={Colors.primary}
          mb={{ xs: 1.25, sm: 2 }}
          sx={{
            fontWeight: 800,
            letterSpacing: 3,
            textAlign: "center",
            textTransform: "uppercase",
          }}
        >
          {translate("about section eyebrow")}
        </Typography>
        <Typography
          variant="h2"
          mt={0}
          sx={{
            color: Colors.navy,
            fontSize: { xs: "2.35rem", md: "4rem" },
            fontWeight: 800,
            letterSpacing: 0,
            lineHeight: 1.08,
            textAlign: "center",
          }}
        >
          {translate("about section header")}
        </Typography>
        <Typography
          variant="h6"
          component="p"
          color={Colors.text}
          mt={{ xs: 1.5, sm: 2 }}
          sx={{
            fontWeight: 500,
            lineHeight: 1.65,
            textAlign: "center",
          }}
        >
          {translate("about section description")}
        </Typography>
      </Box>
    </Box>
  );
};

export default About;
